var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"settings-page full-width",attrs:{"padding":""}},[_c('div',{staticClass:"row justify-center full-width"},[_c('div',{staticClass:"col-sm-10 q-pl-lg"},[_c('div',{staticClass:"q-mb-md full-width"},[_c('page-header',{attrs:{"category":"Settings","title":_vm.activeTitle}})],1),_c(_vm.activeComponent,{tag:"component"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }